import { createAction } from 'redux-actions'
import * as types from 'Redux/Types/ReconciliationTypes'

export const getTransactionData = createAction(types.GET_TRANSACTION_DATA)
export const getTransactionDataFailed = createAction(types.GET_TRANSACTION_DATA_FAILED)
export const getTransactionDataSucceeded = createAction(types.GET_TRANSACTION_DATA_SUCCEEDED)

export const getArchiveTransactionData = createAction(types.GET_ARCHIVE_TRANSACTION_DATA)
export const getArchiveTransactionDataFailed = createAction(
  types.GET_ARCHIVE_TRANSACTION_DATA_FAILED,
)
export const getArchiveTransactionDataSucceeded = createAction(
  types.GET_ARCHIVE_TRANSACTION_DATA_SUCCEEDED,
)

export const updateArchiveTransactionData = createAction(types.UPDATE_ARCHIVE_TRANSACTION_DATA)
export const updateArchiveTransactionDataFailed = createAction(
  types.UPDATE_ARCHIVE_TRANSACTION_DATA_FAILED,
)
export const updateArchiveTransactionDataSucceeded = createAction(
  types.UPDATE_ARCHIVE_TRANSACTION_DATA_SUCCEEDED,
)
